import { merge } from "lodash-es";
import { cloneElement } from "react";
import { useStore } from "zustand";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";

export const TestCollection = new Map();

const getStore = (name) => {
	if (!TestCollection.has(name)) {
		TestCollection.set(name, createStore(immer(() => ({}))));
	}
	const store = TestCollection.get(name);
	return store;
};

export const ABTest = ({ children, name }) => {
	const store = getStore(name);
	const testProps = useStore(store);
	const combinedProps = merge({}, children?.props, testProps);

	if (typeof children === "function") {
		return children(testProps);
	}

	return cloneElement(children, combinedProps);
};

export const withABTest = (Component, { name }) => {
	return (props) => {
		const store = getStore(name);
		const testProps = useStore(store);
		const combinedProps = merge({}, props, testProps);

		return <Component {...combinedProps} />;
	};
};

declare global {
	interface Window {
		LEXUS?: any;
	}
}

export const mountTestCollectionToWindow = () => {
	if (!window.LEXUS) {
		window.LEXUS = {};
	}
	if (!window?.LEXUS?.TestCollection) {
		window.LEXUS.TestCollection = TestCollection;
	}
};

mountTestCollectionToWindow();
